import moment from 'moment'
import { DRIVER_ACTUALS_TIMELINE_SLOTS } from '@/helpers/driver_actuals_timeline'

function cellCacheKey(day, hour, minutes) {
  return `${day}|${hour}|${minutes}`
}

function getRowSegments(row) {
  if (!row)
    return []
  if (row.row_type === 'merged' && row.segments)
    return row.segments
  return [row]
}

function segmentOverlapsTimelineDay(segment, day) {
  if (!segment || !segment.start_date || !segment.finish_date)
    return false
  const dayM = moment(day, 'MM-DD-YYYY')
  const start = moment(segment.start_date, 'MM-DD-YYYY')
  const finish = moment(segment.finish_date, 'MM-DD-YYYY')
  return !dayM.isBefore(start, 'day') && !dayM.isAfter(finish, 'day')
}

export function attachTimelineCellCaches(rows, timelineDays, timelineApi) {
  const { getCellBarClasses, getSegmentsAtCell } = timelineApi
  for (const row of rows) {
    const classCache = Object.create(null)
    const segmentCache = Object.create(null)
    const segments = getRowSegments(row)
    if (!segments.length) {
      row._cellClassCache = classCache
      row._cellSegmentCache = segmentCache
      continue
    }

    for (const day of timelineDays) {
      if (!segments.some(seg => segmentOverlapsTimelineDay(seg, day)))
        continue

      for (const slot of DRIVER_ACTUALS_TIMELINE_SLOTS) {
        for (const slice of slot.slices) {
          const segmentsAtCell = getSegmentsAtCell(row, day, slice.hour, slice.minutes)
          if (!segmentsAtCell.length)
            continue
          const key = cellCacheKey(day, slice.hour, slice.minutes)
          segmentCache[key] = segmentsAtCell
          const classes = getCellBarClasses(row, day, slice.hour, slice.minutes)
          if (classes.length)
            classCache[key] = classes
        }
      }
    }
    row._cellClassCache = classCache
    row._cellSegmentCache = segmentCache
  }
  return rows
}

export function prepareTimelineDisplayRows(rawRows, enrichFn, timelineDays, timelineApi) {
  const enriched = enrichFn(rawRows || [])
  return attachTimelineCellCaches(enriched, timelineDays, timelineApi)
}

export function getCachedCellClasses(row, day, hour, minutes) {
  if (!row || !row._cellClassCache)
    return []
  return row._cellClassCache[cellCacheKey(day, hour, minutes)] || []
}

export function getCachedCellSegments(row, day, hour, minutes) {
  if (!row || !row._cellSegmentCache)
    return []
  return row._cellSegmentCache[cellCacheKey(day, hour, minutes)] || []
}
